import React, { FC, useCallback } from 'react';

import {
    VodPlayerController,
    VodPlayerControllerProps,
} from '../../../../vod-player/ui/VodPlayerController';
import { useOnFinishEpisode } from '../../../../episode-player/hooks/use-on-finish-episode';
import { usePlaybackRateWatcher } from '../../../../episode-player/hooks/use-playback-rate-watcher';
import { useVideoToken } from '../../../../episode-player/hooks/use-video-token';

export const EpisodePlayerController: FC<VodPlayerControllerProps> = ({
    onFinish,
    contentId,
    ...props
}) => {
    const { onFinish: onFinishAutoSkip } = useOnFinishEpisode({
        contentId,
    });
    const videoToken = useVideoToken(contentId);

    const onFinishWrapped = useCallback(() => {
        onFinishAutoSkip();
        onFinish?.();
    }, [onFinish, onFinishAutoSkip]);

    usePlaybackRateWatcher();

    return (
        <VodPlayerController
            contentId={contentId}
            videoToken={videoToken}
            onFinish={onFinishWrapped}
            {...props}
        />
    );
};
